import styled from 'styled-components';
import { squareBulletPoints } from '../styled/lists';

export const ModuleWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const FormWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  ${({ $backgroundColor, theme }) =>
    $backgroundColor === 'grey' &&
    `
      padding:${theme.spacing.standard} ${theme.spacing.standard} 0 ${theme.spacing.standard};
      background-color: ${theme.palette.lightBackground};
      border: 1px solid ${theme.palette.border};`}
`;

export const FormFieldWrapper = styled.div`
  margin: 0 0 ${({ theme }) => theme.spacing.standard};
`;

export const PreviousButtonWrapper = styled.span`
  margin-right: 16px;
`;

export const ErrorListWrapper = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.errorBorder};
  padding: ${({ theme }) => theme.spacing.small};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  background-color: ${({ theme }) => theme.palette.white};

  ul {
    list-style: none;
    ${squareBulletPoints};
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.tiny};
  }

  ul li {
    margin-bottom: ${({ theme }) => theme.spacing.tiny};
    &::before {
      background: ${({ theme }) => theme.palette.errorBorder};
    }
  }
`;
